import Article from 'components/Page/Article/Article';

export default Article;
